import { addNombreCentreSaga } from './addNombreCentrePrivee'
import { getAllPrivateCentersSaga } from './getAllPrivateCenters'
import { deleteNombreCentreSaga } from './deleteNombreCentrePrive'
import { editNombreCentreSaga } from './editNombreCentrePrive'

const NombreCentreSagas = [
    deleteNombreCentreSaga,
    editNombreCentreSaga,
    addNombreCentreSaga,
    getAllPrivateCentersSaga,
]
export default NombreCentreSagas
